import React from 'react';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';
import { intl } from '../../../../locales/localesConfig';

const FormulaEditorLink = React.forwardRef((props, ref) => {
  const {
    className,
    value,
    handleEditFormulaLink,
    labelLocale,
    pendingSave,
    miniLayout,
    propsTarget,
    disabled
  } = props;
    
  const dataPath = props["data-path"];
  const dataFinalPath = props["data-finalpath"];
  const dataDisableMarkMode = props["data-disablemarkmode"];
  const dataDisableFunctions = props["data-disablefunctions"];
  const dataLabel = props["data-label"];
  const dataFormulaType = props["data-formulatype"];
  let finalValue = (value && value.length>0) ? intl.formatMessage({id:"polynomialAdmin.formulaEditor.formulaEditorLinkValueText"}) : "";
  if(miniLayout) {
    return (
      <div 
        className="simulated-a formula-editor-link-mini"
        onClick={handleEditFormulaLink}
        data-path={dataPath}
        data-label={dataLabel}
        data-propstarget={propsTarget}
        data-onlyread={disabled}
        data-formulatype={dataFormulaType}
        data-disablemarkmode={dataDisableMarkMode}
        data-disablefunctions={dataDisableFunctions}
        data-finalpath={dataFinalPath}
      >
        {disabled ? intl.formatMessage({id:"polynomialAdmin.formulaEditor.formulaEditorMiniLinkTextDisabled"}) : intl.formatMessage({id:"polynomialAdmin.formulaEditor.formulaEditorMiniLinkText"})}
      </div>
    );
  }
  return (
    <label 
      onClick={handleEditFormulaLink} 
      data-path={dataPath} 
      data-label={dataLabel} 
      data-onlyread={disabled} 
      data-formulatype={dataFormulaType} 
      data-propstarget={propsTarget} 
      data-disablemarkmode={dataDisableMarkMode} 
      data-disablefunctions={dataDisableFunctions} 
      data-finalpath={dataFinalPath} 
      className={"custom-input matter-textfield-outlined formula-editor-link" + (className ? " " + className : "") + (pendingSave ? " hasPendingSave" : "") }
    >
      <input 
        placeholder=" "     
        value={finalValue}
        disabled={true}
      />
      <span>{labelLocale}</span>
      <div className="formula-editor-link_formula-preview">
      </div>
      <i 
        className={"fas " + (disabled ? "fa-eye" : "fa-edit")}
      />
    </label>
  );
});

export default FormulaEditorLink;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/formulaEditorLink.jsx